export default [
    {
        path: '/route',
        name: 'route',
        component: () => import('@/views/menu/flight/route.vue'),
        meta: {
            pageTitle: 'مدیریت مسیرها',
            action: 'show',
            resource: 'RouteManager',
        },
    },
    {
        path: '/country',
        name: 'country',
        component: () => import('@/views/menu/flight/country.vue'),
        meta: {
            pageTitle: 'مدیریت کشورها',
            action: 'show',
            resource: 'CountryManager',
        },
    },
    {
        path: '/city',
        name: 'city',
        component: () => import('@/views/menu/flight/city.vue'),
        meta: {
            pageTitle: 'مدیریت شهرها',
            action: 'show',
            resource: 'CityManager',
        },
    },
    {
        path: '/airport',
        name: 'airport',
        component: () => import('@/views/menu/flight/airport.vue'),
        meta: {
            pageTitle: 'مدیریت فرودگاه‌ها',
            action: 'show',
            resource: 'AirportManager',
        },
    },
    {
        path: '/airport/details',
        name: 'addairport',
        component: () => import('@/views/menu/flight/airportdetails.vue'),
        meta: {
            pageTitle: 'ایجاد فرودگاه',
            action: 'show',
            resource: 'AirportManager',
        },
    },
    {
        path: '/airport/details/:id',
        name: 'updateairport',
        component: () => import('@/views/menu/flight/airportdetails.vue'),
        meta: {
            pageTitle: 'ویرایش فرودگاه',
            action: 'show',
            resource: 'AirportManager',
        },
    },
    {
        path: '/airline',
        name: 'airline',
        component: () => import('@/views/menu/flight/airline.vue'),
        meta: {
            pageTitle: 'مدیریت ایرلاین‌ها',
            action: 'show',
            resource: 'AirlineManager',
        },
    },
    {
        path: '/airline/details',
        name: 'addairline',
        component: () => import('@/views/menu/flight/airlinedetails.vue'),
        meta: {
            pageTitle: 'ایجاد ایرلاین',
            action: 'show',
            resource: 'AirlineManager',
        },
    },
    {
        path: '/airline/details/:id',
        name: 'updateairline',
        component: () => import('@/views/menu/flight/airlinedetails.vue'),
        meta: {
            pageTitle: 'ویرایش ایرلاین',
            action: 'show',
            resource: 'AirlineManager',
        },
    },
    {
        path: '/airplane',
        name: 'airplane',
        component: () => import('@/views/menu/flight/airplane.vue'),
        meta: {
            pageTitle: 'مدیریت هواپیماها',
            action: 'show',
            resource: 'AirplaneManager',
        },
    },
    {
        path: '/airplane/details',
        name: 'addairplane',
        component: () => import('@/views/menu/flight/airplanedetails.vue'),
        meta: {
            pageTitle: 'ایجاد هواپیما',
            action: 'show',
            resource: 'AirplaneManager',
        },
    },
    {
        path: '/airplane/details/:id',
        name: 'updateairplane',
        component: () => import('@/views/menu/flight/airplanedetails.vue'),
        meta: {
            pageTitle: 'ویرایش هواپیما',
            action: 'show',
            resource: 'AirplaneManager',
        },
    },
    {
        path: '/flight',
        name: 'flight',
        component: () => import('@/views/menu/flight/flight.vue'),
        meta: {
            pageTitle: 'مدیریت پروازها',
            action: 'show',
            resource: 'FlightManager',
        },
    },
    {
        path: '/flight/details',
        name: 'addflight',
        component: () => import('@/views/menu/flight/flightdetails.vue'),
        meta: {
            pageTitle: 'ایجاد پرواز',
            action: 'show',
            resource: 'FlightManager',
        },
    },
    {
        path: '/flight/details/:id',
        name: 'updateflight',
        component: () => import('@/views/menu/flight/flightdetails.vue'),
        meta: {
            pageTitle: 'ویرایش پروازها',
            action: 'show',
            resource: 'FlightManager',
        },
    },
]
